// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qQz_R","colMin":"styles_colMin__2n0Mp"};